"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoyaltyDialogResults = exports.LoyaltyDialogResultEvent = void 0;
Object.defineProperty(exports, "Method", {
  enumerable: true,
  get: function () {
    return _addToBasket.Method;
  }
});
exports.isLoyaltyCloseResult = exports.isLoyaltyBuyForPointsResult = exports.isLoyaltyBuyForMoneyResult = exports.Results = exports.Name = void 0;
var _addToBasket = require("@ori-events/add-to-basket");
const Name = exports.Name = 'loyalty-dialog-result';
const LoyaltyDialogResultEvent = exports.LoyaltyDialogResultEvent = Name;
let LoyaltyDialogResults = exports.LoyaltyDialogResults = /*#__PURE__*/function (LoyaltyDialogResults) {
  LoyaltyDialogResults["CLOSE"] = "CLOSE";
  return LoyaltyDialogResults;
}({});
let Results = exports.Results = function (Results) {
  Results["CLOSE"] = "CLOSE";
  Results[Results["BUY_FOR_MONEY"] = _addToBasket.Method.BUY_FOR_MONEY] = "BUY_FOR_MONEY";
  Results[Results["BUY_FOR_POINTS"] = _addToBasket.Method.BUY_FOR_POINTS] = "BUY_FOR_POINTS";
  return Results;
}({});
const isLoyaltyBuyForMoneyResult = result => result === _addToBasket.Method.BUY_FOR_MONEY;
exports.isLoyaltyBuyForMoneyResult = isLoyaltyBuyForMoneyResult;
const isLoyaltyBuyForPointsResult = result => result === _addToBasket.Method.BUY_FOR_POINTS;
exports.isLoyaltyBuyForPointsResult = isLoyaltyBuyForPointsResult;
const isLoyaltyCloseResult = result => result === LoyaltyDialogResults.CLOSE;
exports.isLoyaltyCloseResult = isLoyaltyCloseResult;
